import { Link, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LayoutDashboard, FileText, Users, Calendar, LogOut } from "lucide-react";

const NAV = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, testId: "nav-dashboard", exact: true },
    { to: "/admin/applications", label: "Applications", icon: FileText, testId: "nav-applications" },
    { to: "/admin/members", label: "Members", icon: Users, testId: "nav-members" },
    { to: "/admin/events", label: "Events", icon: Calendar, testId: "nav-admin-events" },
];

export default function AdminLayout({ children }) {
    const { user, loading, logout } = useAuth();
    const { pathname } = useLocation();

    if (loading) {
        return <div className="min-h-screen flex items-center justify-center text-[#64748B]">Loading…</div>;
    }
    if (!user) return <Navigate to="/admin/login" replace />;

    return (
        <div className="min-h-screen flex bg-[#F8F9FA]">
            <aside data-testid="admin-sidebar" className="w-64 bg-[#0F172A] text-white flex flex-col fixed inset-y-0 left-0">
                <div className="px-6 py-7 border-b border-white/10">
                    <div className="flex items-center gap-3">
                        <div className="h-12 w-12 bg-black flex items-center justify-center overflow-hidden">
                            <img src="https://customer-assets.emergentagent.com/job_form-manage/artifacts/dwtsdzv7_WhatsApp%20Image%202026-05-25%20at%208.11.14%20PM.jpeg" alt="STMF" className="h-full w-full object-cover" />
                        </div>
                        <div className="leading-tight">
                            <div className="font-display font-bold">STMF</div>
                            <div className="text-[10px] uppercase tracking-[0.18em] text-white/60">Admin Portal</div>
                        </div>
                    </div>
                </div>

                <nav className="flex-1 py-6 px-3 space-y-1">
                    {NAV.map(({ to, label, icon: Icon, testId, exact }) => {
                        const active = exact ? pathname === to : pathname.startsWith(to);
                        return (
                            <Link
                                key={to}
                                to={to}
                                data-testid={testId}
                                className={`flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors ${active ? "bg-white/10 text-white border-l-2 border-[#D4AF37]" : "text-white/70 hover:bg-white/5 hover:text-white"}`}
                            >
                                <Icon className="w-4 h-4" />
                                {label}
                            </Link>
                        );
                    })}
                </nav>

                <div className="p-4 border-t border-white/10">
                    <div className="text-xs text-white/50 mb-3 px-2">{user.email}</div>
                    <button
                        onClick={logout}
                        data-testid="admin-logout-btn"
                        className="w-full flex items-center gap-2 px-4 py-2.5 text-sm text-white/80 hover:text-white hover:bg-white/5 transition-colors"
                    >
                        <LogOut className="w-4 h-4" />
                        Sign out
                    </button>
                </div>
            </aside>

            <main className="flex-1 ml-64 min-h-screen">
                <div className="px-10 py-8">{children}</div>
            </main>
        </div>
    );
}
